module.exports = __webpack_public_path__ + "img/welcome2.8d76bfc5.jpg";